import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  MeasurementComponent } from './measurement.component';
import { DistanceConversionPipe } from './distance-conversion.pipe'
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [MeasurementComponent, DistanceConversionPipe],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule
  ],
  exports:[MeasurementComponent]
})
export class MeasurementModule { }
